import { EditPdfDetailsFormModel } from './editPdfDetailsFormModel';
import { RevisionDto } from './RevisionDto';

export type CreateUpdatePdfDetailsCommand = {
  projectId: number;
  designId: number;
  unitId: number;
  numberOfPagesNotIncluded: number;
  waterBufferSizeInLitres: number;
  boilerCapacityInKilowatts: number;
  revisions: Array<RevisionDto>;
};

export const mapEditPdfDetailsFormModelToCommand = (
  projectId: number,
  designId: number,
  unitId: number,
  form: EditPdfDetailsFormModel,
): CreateUpdatePdfDetailsCommand => ({
  projectId,
  designId,
  unitId,
  ...form,
  numberOfPagesNotIncluded: Number(form.numberOfPagesNotIncluded),
  waterBufferSizeInLitres: Number(form.waterBufferSizeInLitres),
  boilerCapacityInKilowatts: Number(form.boilerCapacityInKilowatts),
});
